import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable({providedIn: 'root'})
export class UrlService {
  constructor(private readonly translate: TranslateService) {}

  getLogsysUrl(): string {
    const lang = this.translate.currentLang || 'de';
    return `/system/home?lang=${lang}`;
  }
}
